import { initializeFileHandler, removeFile } from '../../packs/vehicles/shared/uploader_utils';

document.addEventListener('turbolinks:load', function () {
  if ($('.projects.new, .projects.create, .projects.edit, .projects.update').length === 0) {
    return;
  }

  const container = document.querySelector('#design-documents-container .upload-form.file-upload-area');
  const fileField = document.getElementById('project_design_documents');
  const previewsContainer = document.querySelector('[data-preview=design-documents-preview]');

  if (!container || !fileField || !previewsContainer) {
    return;
  }

  const selectedDesignDocuments = [];
  initializeFileHandler(container, fileField, previewsContainer, selectedDesignDocuments);

  previewsContainer.querySelectorAll('.file-preview').forEach(function (filePreview) {
    filePreview.addEventListener('click', (e) => removeFile(e, selectedDesignDocuments));
  });

  // handled design document required-field validation here for project instead of touching
  // shared multi-step-form js
  const errorMessage = 'Please select at least one file';

  function syncErrorState() {
    const isInvalid = fileField.classList.contains('is-invalid') || fileField.classList.contains('error-field');
    const existingMessage = container.nextElementSibling && container.nextElementSibling.classList.contains('msf-error')
      ? container.nextElementSibling
      : null;

    if (isInvalid) {
      container.classList.add('is-invalid', 'error-field');
      if (!existingMessage) {
        container.insertAdjacentHTML('afterend', `<div class="msf-error error-message text-danger small mt-1">${errorMessage}</div>`);
      }
    } else {
      container.classList.remove('is-invalid', 'error-field');
      if (existingMessage) {
        existingMessage.remove();
      }
    }
  }

  new MutationObserver(syncErrorState).observe(fileField, { attributes: true, attributeFilter: ['class'] });
});
